import React, { useContext } from "react";
import { AppContext } from "../../contexts/AppContext";
import cogoToast from "cogo-toast";
import api from "../../actions/common";
import AuthContext from "../../contexts/AuthContext";
import { getStory, postReading } from "../../actions/story";
import { useAuth } from "../Auth/AuthHooks";

export const useStory = (storyID, args = {}) => {
  const { story, stories, storyDispatch } = useContext(AppContext);
  const { token } = React.useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);

  console.log([story, storyDispatch, token, storyID]);
  React.useEffect(() => {
    if (
      (!story || Object.keys(story).length === 0 || story._id !== storyID) &&
      storyID
    ) {
      const alreadyLoaded = stories.filter((s) => s._id === storyID);
      if (alreadyLoaded.length > 0) {
        storyDispatch({
          type: "set",
          payload: {
            ...alreadyLoaded[0],
            coverImageBackup:
              "https://epic-staging-data.s3.us-east-2.amazonaws.com/upload/cover/5b52bbef53754.gif",
          },
        });
      } else {
        getStory(storyDispatch, storyID, token, args, setLoading);
      }
    }
  }, [story, storyDispatch, token, storyID]);

  if (!storyID) {
    const setStory = (formData) => postStory(formData, token, setLoading);
    return [setStory, loading];
  }

  return [story, loading];
};

export const useStories = (args, force = true, reset) => {
  const { stories, storiesDispatch } = React.useContext(AppContext);
  const { token } = useAuth();

  const [loading, setLoading] = React.useState(false);
  const [forced, setForced] = React.useState(false);

  React.useEffect(() => {
    if (
      (stories.length === 0 || (force && !forced)) &&
      stories.filter((s) => s.type === args.type).length < 10
    ) {
      getStories(storiesDispatch, token, args, setLoading);
      if (force) {
        setForced(true);
      }
    }
  }, [storiesDispatch, token]);

  if (args.type) {
    return [stories.filter((s) => s.type === args.type), loading];
  } else {
    return [stories, loading];
  }
};

export const useReading = (storyID) => {
  const { token } = React.useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);
  const setReading = () => postReading(storyID, token, setLoading);

  return [setReading, loading];
};

const getStories = async (dispatch, token, args = {}, setLoading) => {
  let stories = [];
  const response = await api.get(`/stories/`, token, args, setLoading);

  if (response.status || response.success) {
    stories = response.stories.map((story) => ({
      ...story,
      // coverImageBackup: constants.covers[num()],
      type: args.type,
    }));
  } else {
    cogoToast.error(response.message);
    return;
  }

  if (stories.length > 0) {
    dispatch({
      type: "addall",
      payload: stories,
    });
  }
};

const postStory = async (formData, token, setLoading) => {
  const resp = await api.set("/stories/create", token, formData, setLoading);
  return resp;
};

// const num = () => Math.floor(Math.random() * constants.covers.length);
